import React from "react";
import { Classes } from "jss";
import {
  IconButton,
  TextField,
  createStyles,
  Theme,
  withStyles
} from "@material-ui/core";
import { Icon } from "../icons/Icon";

type Props = {
  classes: Classes;
  onSubmit?: () => void;
  onUpdate?: (e: any) => void;
  onReset?: () => void;
  value?: string;
};

const styles = (theme: Theme) =>
  createStyles({
    searchWrapper: {
      alignItems: "center",
      display: "flex",
      marginRight: theme.spacing(1),
      minWidth: "160px"
    }
  });

const SearchField = ({ classes, onSubmit, onUpdate, onReset, value }: Props) => (
  <div className={classes.searchWrapper}>
    <TextField
      onChange={onUpdate}
      onKeyPress={ev => {
        if (ev.key === "Enter") {
          onSubmit && onSubmit();
        }
      }}
      placeholder="Search"
      value={value}
    />
    <IconButton onClick={onSubmit}>
      <Icon name="search" />
    </IconButton>
    <IconButton onClick={onReset}>
      <Icon name="close" />
    </IconButton>
  </div>
);

const styled = withStyles(styles)(SearchField);
export { styled as SearchField };
